import { siteContentOverrides } from '../config/appConfig';
import siteData from '../data/site.json';
import type { SiteConfig } from '../models/SiteConfig';

/**
 * The memorial's details while no backend is configured.
 *
 * Held here rather than in either service because both need it: the admin page
 * writes through `adminService` and the home page reads through `siteService`,
 * and without somewhere in between, saving would report success and change
 * nothing visible. That is a worse demonstration than no admin page at all,
 * because it looks like a bug in the saving.
 *
 * In memory only, and gone on reload -- exactly like the mock memories and
 * photographs beside it. Nothing here runs once VITE_API_URL is set.
 */
function initial(): SiteConfig {
  // The placeholder has no photograph in it: a main photograph is uploaded by
  // an administrator and stored in R2, which mock mode has no part of.
  return {
    ...(siteData as Omit<SiteConfig, 'mainPhoto'>),
    mainPhoto: '',
    ...siteContentOverrides,
  };
}

let current: SiteConfig = initial();

export function readMockSiteConfig(): SiteConfig {
  return { ...current };
}

/**
 * Records what the admin page saved.
 *
 * The photograph is not taken from here for the same reason the Worker refuses
 * it in the body: it is an uploaded object, not a field somebody types into.
 */
export function writeMockSiteConfig(config: SiteConfig): SiteConfig {
  current = { ...config, mainPhoto: current.mainPhoto };
  return readMockSiteConfig();
}

/** Replaces just the photograph, which is uploaded on its own. */
export function writeMockMainPhoto(mainPhoto: string): void {
  current = { ...current, mainPhoto };
}
